import React from "react";
import styled from "styled-components";
import {ControlButton} from "./ControlButton";
import {IDEA_ACTIONS} from "../../authorActions";

const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

const Title = styled.div`
    font-weight: bold;
    font-size: 12px;
    margin-bottom: 3px;
`;

const ControlsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 7px;
    font-size: 16px;
    font-weight: bold;
`;

export const ChangeControls = ({disabled, selectedAction, onActionSelected}) => {
    return <Container>
        <Title>Change</Title>
        <ControlsContainer>
            {
                Object.keys(IDEA_ACTIONS).map(action => {
                    return <ControlButton disabled={disabled}
                                          key={action}
                                          selectedAction={selectedAction}
                                          onActionSelected={onActionSelected}
                                          action={action}/>
                })
            }
        </ControlsContainer>
    </Container>
};